import { render } from "./ImprimirReciboMatricula.vue?vue&type=template&id=093590ea&scoped=true"
import script from "./ImprimirReciboMatricula.vue?vue&type=script&lang=js"
export * from "./ImprimirReciboMatricula.vue?vue&type=script&lang=js"

import "./ImprimirReciboMatricula.vue?vue&type=style&index=0&id=093590ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093590ea"]])

export default __exports__